import { isDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const Step = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const step = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'step'));

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const handleStep = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Step changed', value?.toString() ?? 'null');

    return check({
      step: isDefined(value) ? value : null,
    });
  };

  return (
    <FormField
      formattedMessageId="forwardAccumulator.form.step"
      extra={
        <Tooltip position="right" contents={<FormattedMessage id={'forwardAccumulator.form.step.info'} />}>
          <div className="badge badge-dismissible">
            <em className="icon icon-sm cursor-default line-height-1 text-secondary">info_outline</em>
          </div>
        </Tooltip>
      }
    >
      <TradeCaptureValidationWrapper validation={validation?.step}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          value={isDefined(step) ? step : undefined}
          maxDecimals={9}
          onChange={handleStep}
          size="sm"
          data-e2e="step"
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default Step;
